import { forwardRef, memo } from 'react';
// Material UI imports
import Avatar from '@mui/material/Avatar';
// local imports
import Groups from '../icons/Groups';
// SCSS imports
import { avatar, avatarGrey } from './CohortAvatar.module.scss';

type CohortAvatarProps = {
  readonly grey?: boolean | null;
};

const CohortAvatar = forwardRef<HTMLDivElement, CohortAvatarProps>(({
  grey = false
}, ref) => (
  <Avatar ref={ref} className={grey ? avatarGrey : avatar}>
    <Groups fontSize="large"/>
  </Avatar>
));

CohortAvatar.displayName = 'CohortAvatar';

export default memo(CohortAvatar);
